import { useCallback, useEffect } from 'react';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import getLang from 'LearningCenterUI/utils/getLang';
import UsageTracker from '../../utils/UsageTracker';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { getAwardSharingPath } from '../../utils/RoutingUtils';
import { getMetadataLanguageFallback, SingleCertAchievement, useAchievementByTrackId } from '../../features/achievement';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const noop = () => {};
const AchievementPreviewModal = () => {
  const history = useHistory();
  const match = useRouteMatch();
  const {
    trackId
  } = match.params;
  const {
    achievement
  } = useAchievementByTrackId(trackId);
  const trackName = achievement && getMetadataLanguageFallback(achievement.tracks[0].metadata, getLang()).name;
  useEffect(() => {
    UsageTracker.track('awardInteraction', {
      action: 'view-achievement-preview-modal',
      trackId,
      trackName,
      view: 'achievement-preview-modal'
    });
  }, [trackId, trackName]);
  const handleClose = useCallback(() => {
    UsageTracker.track('awardInteraction', {
      action: 'close-achievement-preview-modal',
      trackId,
      trackName,
      view: 'achievement-preview-modal'
    });
    history.push(getAwardSharingPath(trackId));
  }, [trackId, trackName, history]);
  if (!achievement) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "achievement-preview-modal",
    use: "conversational",
    width: 1250,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      "data-test-id": "achievement-close-preview",
      onClick: handleClose,
      style: {
        marginTop: '2px'
      }
    }), /*#__PURE__*/_jsx(SingleCertAchievement, {
      inModal: true,
      language: getLang(),
      publicId: achievement.publicId,
      trackEvent: noop
    })]
  });
};
export default AchievementPreviewModal;